import {Alert, Button, Card, CardContent, Grid, Skeleton, Stack, Typography} from "@mui/material"
import CardGuarantee from "./CardGuarantee";
import {useEffect, useState} from "react";
import {HttpSolicitationOperations} from "../../../http/solicitation/httpSolicitation";
import {
    SolicitationOperationViewDetail,
    SolicitationOperationViewDetailFields, SolicitationStatusViewDTO, SolicitationStatusViewDTOFields
} from "../../../types/solicitation/solicitationData";
import {HttpSolicitationOnboarding} from "../../../http/solicitation/httpSolicitationOnboarding";
import {useAction} from "../../../hooks/useAction";
import DialogAlert from "../../../components/dialog/DialogAlert";

interface SolicitationGuaranteeProps {
    solicitationId: number,
    solicitationStatus: SolicitationStatusViewDTO,
    onReload: () => void
}

const SolicitationGuarantee = ({solicitationId, solicitationStatus, onReload}: SolicitationGuaranteeProps) => {
    const {snackbarError} = useAction()
    const [loading, setLoading] = useState<boolean>(false)
    const [guarantee, setGuarantee] = useState<SolicitationOperationViewDetail>()
    const [accepted, setAccepted] = useState<boolean>(
        solicitationStatus[SolicitationStatusViewDTOFields.OperationApproved] !== null ?
            solicitationStatus[SolicitationStatusViewDTOFields.OperationApproved] : false
    )
    const [rejected, setRejected] = useState<boolean>(
        solicitationStatus[SolicitationStatusViewDTOFields.OperationApproved] !== null ?
            !solicitationStatus[SolicitationStatusViewDTOFields.OperationApproved] : false
    )
    const [openAccept, setOpenAccept] = useState<boolean>(false)
    const [openReject, setOpenReject] = useState<boolean>(false)

    const handleAccept = () => {
        HttpSolicitationOnboarding.approveGuarantee(solicitationId).then(() => {
            setAccepted(true)
            onReload && onReload()
        }).catch(() => snackbarError('Ocurrió un error al aprobar la propuesta'))
    }
    
    const handleReject = () => {
        HttpSolicitationOnboarding.rejectGuarantee(solicitationId).then(() => {
            setRejected(true)
            onReload && onReload()
        }).catch(() => snackbarError('Ocurrió un error al desistir la propuesta'))
    }
    
    useEffect(() => {
        setLoading(true)
        HttpSolicitationOperations.getOperationsBySolicitationId(solicitationId).then((r) => {
            const availableGuarantees: SolicitationOperationViewDetail[] = r.filter((g) => !g[SolicitationOperationViewDetailFields.Desisted]) 
            if (availableGuarantees.length !== 0) {
                setGuarantee(availableGuarantees[0])
            }
        }).finally(() => setLoading(false))
    }, [])

    return (
        <Grid container>
            {
                loading ?
                    <Grid item xs={12}>
                        <Skeleton height={50}/>
                        <Skeleton height={200}/>
                    </Grid>
                    :
                    guarantee ?
                        <Grid item xs={12}>
                            <Stack spacing={2}>
                                {
                                    (!accepted && !rejected && !(!solicitationStatus[SolicitationStatusViewDTOFields.CanApproveOperation] && solicitationStatus[SolicitationStatusViewDTOFields.OperationApproved] === null)) &&
                                    <Alert severity={'info'}>
                                        Estimado cliente, le informamos nuestra propuesta de acuerdo a tu solicitud.
                                        Recuerde que luego de aceptar o desistirla no llegará una nueva y su solicitud se cerrará.
                                    </Alert>
                                }
                                {
                                    solicitationStatus[SolicitationStatusViewDTOFields.CanApproveOperation] && !accepted && !rejected &&
                                    <Card>
                                        <CardContent>
                                            <Typography fontSize={18} fontWeight={600} textAlign={'center'}>
                                                ¿Desea aceptar esta garantía?
                                            </Typography>
                                            <Stack direction={'row'} justifyContent={'center'} spacing={10} sx={{marginTop: 6}}>
                                                <Button color='error' variant='contained' onClick={() => {setOpenReject(true)}}>
                                                    Desistir
                                                </Button>
                                                <Button variant='contained' color='success' onClick={() => {setOpenAccept(true)}}>
                                                    Aceptar
                                                </Button>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                }
                                {
                                    (!solicitationStatus[SolicitationStatusViewDTOFields.CanApproveOperation] && solicitationStatus[SolicitationStatusViewDTOFields.OperationApproved] === null) ?
                                        <Card>
                                            <CardContent>
                                                <Alert severity={'info'}>Aún no se ha ofrecido ninguna garantía para tu solicitud. Nos contactaremos con usted en cuanto tengamos novedades</Alert>
                                            </CardContent>
                                        </Card>
                                        :
                                        <CardGuarantee guarantee={guarantee}
                                                       accepted={accepted}
                                                       rejected={rejected}
                                        />                   
                                }
                            </Stack>
                            <DialogAlert open={openAccept}
                                         onClose={() => {setOpenAccept(false)}}
                                         title={'Aceptar garantía'}
                                         subtitle={'¿Está seguro de aceptar esta garantía? La acción es irreversible'}
                                         onAccept={handleAccept}
                            />
                            <DialogAlert open={openReject}
                                         onClose={() => {setOpenReject(false)}}
                                         title={'Desistir garantía'}
                                         subtitle={'¿Está seguro de desistir esta garantía? La acción es irreversible'}
                                         onAccept={handleReject}
                            />
                        </Grid>
                        :
                        <Grid item xs={12}>
                            <Alert severity={'info'}>Aún no se ha cargado la propuesta para tu solicitud</Alert>
                        </Grid>
            }
        </Grid>
    )
}

export default SolicitationGuarantee